<app-pa-categorized (onOverAllClick)="handleOnOverAllClick()" (onPACategoryClick)="handleOnPACategoryClick($event)"></app-pa-categorized>